const explicitApiUrl = process.env.REACT_APP_API_URL;
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const inferredApiUrl = hostname.endsWith('elcidresearch.com')
  ? 'https://api.elcidresearch.com'
  : 'http://localhost:5000';

export const apiBaseUrl = explicitApiUrl || inferredApiUrl;
